import React from 'react';
import { BookmarkIcon, ClipboardIcon, XIcon } from 'lucide-react';
const AISuggestionsWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-938">
      <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-939">
        <div className="flex items-center" data-id="element-940">
          <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-pink-500 mr-3" data-id="element-941">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-942" />
          </div>
          <div data-id="element-943">
            <h2 className="text-base font-semibold text-gray-800" data-id="element-944">ALGA</h2>
            <p className="text-xs text-gray-500" data-id="element-945">
              Powered by EIIS Intelligence
            </p>
          </div>
        </div>
      </div>
      <div className="p-4" data-id="element-946">
        <div className="space-y-4" data-id="element-947">
          <div className="p-3 bg-white rounded-lg border border-gray-200" data-id="element-948">
            <div className="flex justify-between items-start mb-2" data-id="element-949">
              <div className="font-medium text-gray-800" data-id="element-950">
                Riassunto della Lezione
              </div>
              <div className="flex space-x-1" data-id="element-951">
                <button className="p-1 hover:bg-gray-100 rounded" data-id="element-952">
                  <BookmarkIcon size={14} className="text-gray-500" data-id="element-953" />
                </button>
                <button className="p-1 hover:bg-gray-100 rounded" data-id="element-954">
                  <XIcon size={14} className="text-gray-500" data-id="element-955" />
                </button>
              </div>
            </div>
            <div className="relative" data-id="element-956">
              <div className="max-h-24 overflow-hidden" data-id="element-957">
                <p className="text-sm text-gray-600 mb-2" data-id="element-958">
                  Basato sulla tua ultima sessione su "Modelli di Business
                  Sostenibili", ecco alcuni punti chiave da ricordare:
                </p>
                <ul className="text-sm text-gray-600 space-y-1 ml-4 list-disc" data-id="element-959">
                  <li data-id="element-960">
                    La Triple Bottom Line considera persone, pianeta e profitto
                  </li>
                  <li data-id="element-961">
                    I modelli di business circolari si concentrano
                    sull'eliminazione dei rifiuti
                  </li>
                  <li data-id="element-962">
                    L'innovazione sostenibile richiede un approccio di pensiero
                    sistemico
                  </li>
                </ul>
              </div>
              <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-transparent pointer-events-none" data-id="element-963"></div>
            </div>
            <div className="mt-3 flex justify-between items-center" data-id="element-964">
              <button className="text-xs text-custom-green hover:text-custom-green/80" data-id="element-965">
                Leggi tutto
              </button>
              <button className="flex items-center text-xs text-lime-600 hover:text-lime-700" data-id="element-966">
                <ClipboardIcon size={12} className="mr-1" data-id="element-967" />
                Copia negli appunti
              </button>
            </div>
          </div>
          <div className="p-3 bg-white rounded-lg border border-gray-200" data-id="element-968">
            <div className="flex justify-between items-start mb-2" data-id="element-969">
              <div className="font-medium text-gray-800" data-id="element-970">
                Suggerimenti di Studio
              </div>
              <div className="flex space-x-1" data-id="element-971">
                <button className="p-1 hover:bg-gray-100 rounded" data-id="element-972">
                  <BookmarkIcon size={14} className="text-gray-500" data-id="element-973" />
                </button>
                <button className="p-1 hover:bg-gray-100 rounded" data-id="element-974">
                  <XIcon size={14} className="text-gray-500" data-id="element-975" />
                </button>
              </div>
            </div>
            <p className="text-sm text-gray-600" data-id="element-976">
              Sembri interessato ai framework di reporting ESG. Considera di
              rivedere la seguente risorsa prima della tua prossima lezione:
            </p>
            <div className="mt-2 p-2 bg-gray-50 rounded border border-gray-200 text-sm" data-id="element-977">
              <div className="font-medium text-gray-800" data-id="element-978">
                Approfondimento sugli Standard di Reporting ESG
              </div>
              <div className="text-xs text-gray-500" data-id="element-979">
                Materiale supplementare • 25 min di lettura
              </div>
            </div>
          </div>
          <div className="p-3 bg-white rounded-lg border border-gray-200" data-id="element-980">
            <div className="flex justify-between items-start mb-2" data-id="element-981">
              <div className="font-medium text-gray-800" data-id="element-982">
                Analisi dei Progressi
              </div>
              <div className="flex space-x-1" data-id="element-983">
                <button className="p-1 hover:bg-gray-100 rounded" data-id="element-984">
                  <BookmarkIcon size={14} className="text-gray-500" data-id="element-985" />
                </button>
                <button className="p-1 hover:bg-gray-100 rounded" data-id="element-986">
                  <XIcon size={14} className="text-gray-500" data-id="element-987" />
                </button>
              </div>
            </div>
            <p className="text-sm text-gray-600" data-id="element-988">
              Stai facendo ottimi progressi! Hai completato il 42% del tuo corso
              di sostenibilità in sole 2 settimane, il che è il 15% più veloce
              rispetto allo studente medio.
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default AISuggestionsWidget;